const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "currentColor",
      fillOpacity: 1
    },
    d: "M 0 2.808594 L 8.082031 1.707031 L 8.085938 9.503906 L 0.0078125 9.550781 Z M 8.078125 10.402344 L 8.085938 18.203125 L 0.0078125 17.09375 L 0.0078125 10.347656 Z M 9.058594 1.5625 L 19.773438 0 L 19.773438 9.402344 L 9.058594 9.488281 Z M 19.773438 10.472656 L 19.773438 19.835938 L 9.058594 18.324219 L 9.042969 10.457031 Z M 19.773438 10.472656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows10);
export default __webpack_public_path__ + "static/media/windows10.d8a08bf1.svg";
export { ForwardRef as ReactComponent };